import React from 'react';
import useLocale from '@/hooks/useLocale';
import type { LocaleWithGatorProtectTrialActive } from '../../../gatorProtect.types';
import {
  ProtectionCardRoot,
  ProtectionCardBody,
  ProtectionCardShield,
  ProtectionCardTextBlock,
  ProtectionCardTitle,
  ProtectionCardDescription,
  ProtectionCardActions,
  ProtectionCardButton,
  ProtectionCardMonarx,
} from '../ProtectionCardCompound';


/** Discriminator for forcing `ProtectionCardFactory` into this variant. */
export const TRIAL_ACTIVE_PROTECTION_CARD_TYPE = 'trialIsActive' as const;
export type TrialActiveProtectionCardType = typeof TRIAL_ACTIVE_PROTECTION_CARD_TYPE;

export type ActiveTrialVariantProps = {
  testId?: string;
  hideButtons?: boolean;
  onActivateProtectionPro?: () => void;
};

const ActiveTrialVariant = ({
  testId,
  hideButtons = false,
  onActivateProtectionPro,
}: ActiveTrialVariantProps) => {
  const { gatorProtect } = useLocale() as LocaleWithGatorProtectTrialActive;
  const summary = gatorProtect && gatorProtect.summary;
  const block = summary && summary.protectionCard && summary.protectionCard.trialIsActive;

  if (!block) {
    return null;
  }

  const activatePro = block.actions && block.actions[0];
  const actionsTestId = `${testId}__actions`;

  return (
    <ProtectionCardRoot testId={testId}>
      <ProtectionCardBody>
        <ProtectionCardShield title={block.title} />
        <ProtectionCardTextBlock>
          <ProtectionCardTitle>{block.title}</ProtectionCardTitle>
          <ProtectionCardDescription html={block.description} />
          {!hideButtons && activatePro && (
            <ProtectionCardActions actionsTestId={actionsTestId}>
              <ProtectionCardButton
                variant={activatePro.variant}
                hasMultipleButtons={false}
                onClick={onActivateProtectionPro}
                testId={`${testId}__action-${activatePro.key}`}
              >
                {activatePro.label}
              </ProtectionCardButton>
            </ProtectionCardActions>
          )}
        </ProtectionCardTextBlock>
      </ProtectionCardBody>
      <ProtectionCardMonarx title={block.title} />
    </ProtectionCardRoot>
  );
};

export default ActiveTrialVariant;
